import { PluginSettingsIcon, BUTTONS } from 'wix-rich-content-plugin-commons';
import { decorateComponentWithProps, getModalStyles } from 'wix-rich-content-editor-common';
import { Modals } from '../modals.js';
import ButtonInputModal from './buttonInputModal.js';
import 'prop-types';
import 'react';
import 'lodash';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import '../components/design-component.js';
import '../components/color-toggle-component.js';
import 'classnames';
import '../style-inject.es-746bb8ed.js';
import '../constants.js';
import 'ricos-schema';
import '../types.js';
import '../defaults.js';
import '../components/settings-component.js';
import '../components/preview-component.js';
import '../button-component.js';
import '../classNameStrategies.js';
import '../default-styles-888649ac.js';
import '../components/button-viewer.js';
import '../viewer/button-viewer.js';
import 'ricos-context';

const DesktopCustomModalStyles = {
  content: {
    width: "420px"
  }
};
const MobileFullScreenCustomStyle = {
  content: {
    width: "100vw"
  }
};
const createInlineButtons = ({
  settings,
  isMobile,
  relValue,
  anchorTarget,
  type
}) => {
  var _a, _b;
  const customStyles = isMobile ? MobileFullScreenCustomStyle : DesktopCustomModalStyles;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.advanced_settings) || PluginSettingsIcon;
  return [
    { keyName: "alignLeft", type: BUTTONS.ALIGN_LEFT, mobile: false },
    { keyName: "alignCenter", type: BUTTONS.ALIGN_CENTER, mobile: false },
    { keyName: "alignRight", type: BUTTONS.ALIGN_RIGHT, mobile: false },
    { keyName: "separator1", type: BUTTONS.SEPARATOR, mobile: false },
    {
      keyName: "advanced_settings",
      type: BUTTONS.EXTERNAL_MODAL,
      fullHeight: true,
      icon,
      modalName: Modals.BUTTON_INPUT,
      activeTab: "advanced_settings",
      modalElement: decorateComponentWithProps(ButtonInputModal, settings),
      modalStyles: getModalStyles({ customStyles, isMobile }),
      mobile: true,
      tooltipTextKey: "SettingsButton_Tooltip",
      settings,
      isMobile,
      triggerSettingsBi: true,
      relValue,
      anchorTarget,
      pluginId: type
    },
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
